import { createRouter, createWebHistory } from 'vue-router'

import isAuthenticatedGuard from '@/modules/auth/router/auth-guard'
import isAuthScapeGuard from '@/modules/auth/router/auth-scape-guard'

import DashboardLayout from '@/shared/layouts/DashboardLayout.vue'
import NotFound from '@/shared/views/NotFound.vue'
import AuthRouter from '@/modules/auth/router'
import CountriesRouter from '@/modules/countries/router'
import StatesRouter from '@/modules/states/router'
import MunicipalitiesRouter from '@/modules/municipalities/router'
import DealersRouter from '@/modules/dealers/router'
import ClassificationsRouter from '@/modules/classifications/router'
import VehiclesRouter from '@/modules/vehicles/router'
import PlacesRouter from '@/modules/places/router'
import TypeproductsRouter from '@/modules/typeproducts/router'
import StafferstypeRouter from '@/modules/stafferstype/router'
import CompaniesRouter from '@/modules/companies/router'
import SubsidiariesRouter from '@/modules/subsidiaries/router'
import RacksRouter from '@/modules/racks/router'
import ClientsRouter from '@/modules/clients/router'
import ProductsRouter from '@/modules/products/router'
import InputsPendingRouter from '@/modules/inputs/pending/router'
import InputsFinalizedRouter from '@/modules/inputs/finalized/router'
import UnitsRouter from '@/modules/units/router'
import InputsCancelledRouter from '@/modules/inputs/cancelled/router'
import OutputsPendingRouter from '@/modules/outputs/pending/router'
import OutputsFinalizedRouter from '@/modules/outputs/finalized/router'
import OutputsCancelledRouter from '@/modules/outputs/cancelled/router'
import ReportsInventoryRouter from '@/modules/reports/inventories/router'
import ReportsPhysicalRouter from '@/modules/reports/physical/router'
import ReportsMovementsRouter from '@/modules/reports/movements/router'
import ReportsPalletsRouter from '@/modules/reports/pallets/router'
import GeneralInventoryRouter from '@/modules/generalInventory/router'
import RolesRouter from '@/modules/roles/router'
import StaffersRouter from '@/modules/staffers/router'

const routes = [
  {
    path: '',
    redirect: '/auth/login',
  },
  {
    path: '/auth',
    beforeEnter: [isAuthScapeGuard],
    ...AuthRouter
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    beforeEnter: [ isAuthenticatedGuard ],
    component: DashboardLayout,
    redirect: '/dashboard/generalinventory',
    children: [
      {
        path: 'countries',
        ...CountriesRouter
      },
      {
        path: 'states',
        ...StatesRouter
      },
      {
        path: 'municipalities',
        ...MunicipalitiesRouter
      },
      {
        path: 'dealers',
        ...DealersRouter
      },
      {
        path: 'classifications',
        ...ClassificationsRouter
      },
      {
        path: 'vehicles',
        ...VehiclesRouter
      },
      {
        path: 'places',
        ...PlacesRouter
      },
      {
        path: 'typeproducts',
        ...TypeproductsRouter
      },
      {
        path: 'stafferstype',
        ...StafferstypeRouter
      },
      {
        path: 'companies',
        ...CompaniesRouter
      },
      {
        path: 'subsidiaries',
        ...SubsidiariesRouter
      },
      {
        path: 'racks',
        ...RacksRouter
      },
      {
        path: 'clients',
        ...ClientsRouter
      },
      {
        path: 'products',
        ...ProductsRouter
      },
      {
        path: 'inputs/pending',
        ...InputsPendingRouter
      },
      {
        path: 'units',
        ...UnitsRouter
      },
      {
        path: 'inputs/finalized',
        ...InputsFinalizedRouter
      },
      {
        path: 'inputs/cancelled',
        ...InputsCancelledRouter
      },
      {
        path: 'outputs/pending',
        ...OutputsPendingRouter
      },
      {
        path: 'outputs/finalized',
        ...OutputsFinalizedRouter
      },
      {
        path: 'outputs/cancelled',
        ...OutputsCancelledRouter
      },
      {
        path: 'reports/inventory',
        ...ReportsInventoryRouter
      },
      {
        path: 'reports/physical',
        ...ReportsPhysicalRouter
      },
      {
        path: 'reports/movements',
        ...ReportsMovementsRouter
      },
      {
        path: 'reports/pallets',
        ...ReportsPalletsRouter
      },
      {
        path: 'generalinventory',
        ...GeneralInventoryRouter
      },
      {
        path: 'roles',
        ...RolesRouter
      },
      {
        path: 'staffers',
        ...StaffersRouter
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router